import { Img } from "ui-kit/components-branded/index"

export function PriceEmoji() {
    return <Img className="booking__small-emoji" src="credit-card-emoji.png" />
}
